module.exports = __webpack_public_path__ + "img/honor3.26c51c62.png";